// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"a2f98e3f","471":"cc1ad310","705":"a31bcc18","893":"1bb6e4f4"}[chunkId] + ".chunk.css";
};